/**
 * The permission keys a member screen asks `can()` about.
 *
 * The session carries the keys the API's own guards check, expanded by the
 * server from the six company domains, so a screen asks the very question the
 * server will ask. These are those keys, named once; a screen never spells one.
 */

export const PERMISSION = {
  /** «عرضه»: publish, edit and cancel an offer. */
  offerCreate: 'offer.create',
  offerCancel: 'offer.cancel',
  /** «تقاضا»: publish, edit and cancel a demand. */
  rfqCreate: 'rfq.create',
  rfqCancel: 'rfq.cancel',
  /** «معامله»: place and withdraw a bid. */
  bidPlace: 'bid.place',
  /** «امور مالی»: pay a commission. */
  commissionPay: 'commission.pay',
  /** «کاربران»: open, change and close the company's users. */
  members: 'company.user.manage',
} as const
